export const base_url = 'https://pwa.allislandfence.com/backend';
export const api_createAccount = `${base_url}/post_account.php`;
export const api_submitReferral = `${base_url}/post_lead.php`;
export const api_getReferral = `${base_url}/get_referrals.php`;
